module.exports = __webpack_public_path__ + "img/20191227154714478.fcebb325.jpg";